export default __webpack_public_path__ + "e2caf62ef21ee577f18121739fdca39f.jpg";